import { jsx } from "@emotion/react/jsx-runtime";
import TeaserCard from "./TeaserCard.mjs";
import useThemeProps from "./useThemeProps.mjs";
function Teaser(props) {
  props = useThemeProps({
    props,
    name: "Teaser"
  });
  console.warn("<Teaser> is deprecated. Use <TeaserCard> instead.");
  return /* @__PURE__ */jsx(TeaserCard, {
    ...props
  });
}
export { Teaser as default };